export enum PdpTemplate {
  SingleUnitVr = 'SINGLE_UNIT_VR',
  ConventionalLodging = 'CONVENTIONAL_LODGING',
}

const PDP_BASE_TEMPLATES = Object.values(PdpTemplate);
export const isBasePdpTemplate = (value: string) => PDP_BASE_TEMPLATES.includes(value as PdpTemplate);

export const isPdpTemplate = (value: string) =>
  PDP_BASE_TEMPLATES.some(baseTemplate => baseTemplate.concat('_LARGE') === value || baseTemplate.concat('_SMALL') === value);

export enum SrpTemplate {
  ListView = 'LIST_VIEW',
  SplitView = 'SPLIT_VIEW',
  listViewPillsExp = 'LIST_VIEW_PILLS_EXP',
}

const SRP_TEMPLATES = Object.values(SrpTemplate);

export const isSrpTemplate = (value: string): value is SrpTemplate => SRP_TEMPLATES.includes(value as SrpTemplate);

export type PageTemplate = PdpTemplate | SrpTemplate;
